import React, { useEffect, useState } from "react";
import { Plus, Pencil, X } from "lucide-react";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

export default function QueuesSettings() {
  const [queues,  setQueues]  = useState([]);
  const [draft,   setDraft]   = useState({ name: "", email: "", round_robin: true });
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [msg,     setMsg]     = useState(null);
  const [showForm,setShowForm]= useState(false);
  const token = localStorage.getItem("token");

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/tickets/queues`, { headers: { Authorization: `Bearer ${token}` } });
      setQueues(Array.isArray(await res.json()) ? await res.json() : []);
    } catch { setQueues([]); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!draft.name) return;
    setSaving(true); setMsg(null);
    try {
      await fetch(`${API}/api/admin/tickets/queues`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(draft),
      });
      setDraft({ name: "", email: "", round_robin: true }); setEditing(null); setShowForm(false);
      setMsg("✓ Saved."); await load();
    } catch (e) { setMsg(`⚠ ${e.message}`); }
    finally { setSaving(false); }
  };

  const remove = async (name) => {
    await fetch(`${API}/api/admin/tickets/queues/${name}`, { method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
    setQueues(q => q.filter(x => x.name !== name));
  };

  const startEdit = (q) => { setDraft({ ...q }); setEditing(q.name); setShowForm(true); };

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Queues / Teams</span>
        <div className="flex items-center gap-2">
          <span className="text-xs text-white/30">{queues.length}</span>
          <button onClick={() => { setDraft({ name: "", email: "", round_robin: true }); setEditing(null); setShowForm(v => !v); }}
            className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
            <Plus size={12} /> Add
          </button>
        </div>
      </div>
      {showForm && (
        <div className="px-5 py-4 border-b border-white/5 bg-[#00ff90]/3 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><label className={labelCls}>Queue Name</label><input className={inputCls} value={draft.name} onChange={e => setDraft(d => ({...d, name: e.target.value}))} placeholder="IT Help Desk" disabled={!!editing} /></div>
            <div><label className={labelCls}>Email</label><input className={inputCls} value={draft.email} onChange={e => setDraft(d => ({...d, email: e.target.value}))} placeholder="ithelp@company.com" /></div>
          </div>
          <label className="flex items-center gap-2 cursor-pointer text-sm text-white/50">
            <input type="checkbox" checked={!!draft.round_robin} onChange={e => setDraft(d => ({...d, round_robin: e.target.checked}))} className="w-4 h-4 accent-[#00ff90]" />
            Round-robin assignment
          </label>
          {msg && <p className={`text-xs ${msg.startsWith("⚠") ? "text-red-400" : "text-[#00ff90]"}`}>{msg}</p>}
          <div className="flex gap-2 justify-end">
            <button onClick={() => setShowForm(false)} className="text-xs px-3 py-1.5 rounded-lg border border-white/10 text-white/40 hover:text-white transition-colors">Cancel</button>
            <button onClick={save} disabled={saving}
              className="text-xs px-4 py-1.5 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors">
              {saving ? "Saving…" : "Save Queue"}
            </button>
          </div>
        </div>
      )}
      <div className="divide-y divide-white/5 max-h-64 overflow-y-auto">
        {loading ? <div className="p-4"><div className="h-8 rounded-lg bg-white/5 animate-pulse" /></div>
        : queues.length === 0 ? <p className="px-5 py-4 text-white/20 text-xs italic text-center">No queues configured.</p>
        : queues.map(q => (
          <div key={q.name} className="flex items-center justify-between px-5 py-3">
            <div>
              <p className="text-sm text-white/70 font-medium">{q.name}</p>
              <p className="text-xs text-white/30">{q.email || "—"} · RR: {q.round_robin ? "Yes" : "No"}</p>
            </div>
            <div className="flex gap-1.5">
              <button onClick={() => startEdit(q)} className="w-7 h-7 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/30 hover:text-[#00ff90] transition-colors"><Pencil size={12} /></button>
              <button onClick={() => remove(q.name)} className="w-7 h-7 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/30 hover:text-red-400 transition-colors"><X size={12} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}